// frontend/admin-portal/src/components/procurement/PurchaseOrderFilters.jsx
import React from "react";
import { Input } from "@fiberhome/shared-ui";

export default function PurchaseOrderFilters({
  filters,
  onChange,
  suppliers = [],
}) {
  const set = (key, value) => onChange({ ...filters, [key]: value, page: 1 });

  return (
    <div className="fh-supplier-filters">
      <Input
        placeholder="Search PO number..."
        value={filters.search || ""}
        onChange={(e) => set("search", e.target.value)}
      />
      <select
        className="fh-input"
        value={filters.supplierId || ""}
        onChange={(e) => set("supplierId", e.target.value)}
      >
        <option value="">All suppliers</option>
        {suppliers.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
      <select
        className="fh-input"
        value={filters.status || ""}
        onChange={(e) => set("status", e.target.value)}
      >
        <option value="">All statuses</option>
        <option value="draft">Draft</option>
        <option value="sent">Sent</option>
        <option value="partially_received">Partially received</option>
        <option value="received">Received</option>
        <option value="cancelled">Cancelled</option>
      </select>
    </div>
  );
}
